import React, { Component } from 'react';
import { Platform, ActionSheetIOS, TouchableOpacity } from 'react-native';
import PropTypes from 'prop-types';
import Icon from 'react-native-vector-icons/Ionicons';
import RNBottomSheet from 'react-native-bottomsheet';
import { View, DividerLine, Image, Row } from 'modules/styled';
import { colors } from 'styles';
import Bio from './bio.component';
import ProfileStats from '../profile.stats';

const defaultImg = require('public/img/default_user.jpg');

let ActionSheet = ActionSheetIOS;

if (Platform.OS === 'android') {
  ActionSheet = RNBottomSheet;
  ActionSheet.showActionSheetWithOptions = RNBottomSheet.showBottomSheetWithOptions;
}

class ProfileComponent extends Component {
  static propTypes = {
    actions: PropTypes.object,
    user: PropTypes.object,
    isOwner: PropTypes.bool,
    scrollTo: PropTypes.func,
  };

  constructor(props, context) {
    super(props, context);
    this.setTag = this.setTag.bind(this);
    this.showActionSheet = this.showActionSheet.bind(this);
    this.initTooltips = this.initTooltips.bind(this);
    this.toggleTooltip = this.toggleTooltip.bind(this);
  }

  toggleTooltip() {
    this.props.actions.createToggleAction('relevance', this.tooltipParent);
  }

  initTooltips() {
    this.props.actions.setTooltipData({
      name: 'relevance',
      toggle: () => this.toggleTooltip(),
    });
  }

  showActionSheet(id) {
    ActionSheet.showActionSheetWithOptions(
      {
        options: ['Block User', 'Cancel'],
        cancelButtonIndex: 1,
        destructiveIndex: 0,
      },
      (buttonIndex) => {
        switch (buttonIndex) {
          case 0:
            this.props.actions.updateBlock(id);
            break;
          default:
        }
      }
    );
  }

  setTag(tag) {
    if (!this.props.actions) return;
    this.props.actions.selectTag({ _id: tag.replace('#', '') });
    this.props.actions.changeTab('discover');
    this.props.actions.resetRoutes('discover');
  }

  setCat(cat) {
    if (!this.props.actions) return;
    this.props.actions.selectTag({
      _id: cat,
      category: true,
      categoryName: cat.replace('_category_tag', ''),
    });
    this.props.actions.changeTab('discover');
    this.props.actions.resetRoutes('discover');
  }

  goToTopic(tag) {
    const name = tag.replace('#', '').trim();
    const topic = {
      _id: name,
      categoryName: '#' + name,
    };
    this.props.actions.goToTopic(topic);
  }

  render() {
    const { user, isOwner } = this.props;

    const userImage = user && user.image ? { uri: user.image } : defaultImg;

    const optionsEl = !isOwner && (
      <TouchableOpacity
        style={{
          position: 'absolute',
          right: 0,
          top: 0,
          paddingVertical: 10,
          paddingHorizontal: 15,
        }}
        onPress={() => this.showActionSheet(user._id)}
      >
        <Icon name="ellipsis-horizontal" size={24} color={colors.black} />
      </TouchableOpacity>
    );
    return (
      <View sx={{ bg: 'white', p: 2, pb: 0 }}>
        <Image
          resizeMode={'cover'}
          sx={{
            alignSelf: 'center',
            width: 21 * 8,
            height: 21 * 8,
            borderRadius: 21 * 4,
          }}
          source={userImage}
        />
        {optionsEl}

        <Row sx={{ my: 2, justifyContent: 'center', alignItems: 'baseline' }}>
          <ProfileStats user={user} isOwner={isOwner} />
        </Row>

        {user.bio !== '' || this.props.isOwner ? (
          <Bio
            scrollTo={this.props.scrollTo}
            user={user}
            actions={this.props.actions}
            isOwner={this.props.isOwner}
          />
        ) : null}
        <DividerLine />
      </View>
    );
  }
}

export default ProfileComponent;
